import { IFundManagersCarouselStyle } from '../models/index.js';
export const fundManagersCarouselStyle: IFundManagersCarouselStyle = {
	overrides: [
		{
			selector: '[data-selector="management-fundManager-wrapper"]',
			style: {
				margin: {
					_value: '0 auto',
				},
			},
		},
	],
};
